import { Image as AntImage, Space } from "antd";
import numeral from "numeral";

type ProductProps = {
  product: {
    id: number;
    merchantId: number;
    isSales: boolean;
    brand: {
      id: number;
      name: string;
      types: string[];
    };
    type: string;
    modal: string;
    title: string;
    years: number;
    price: number;
    tags: string[];
    color?: string;
    kilometers: number;
    licensePlate: string;
    imageUrl: string;
    creator: {
      id: number;
      name: {};
      email: string;
    };
    travelLicenseImagePath?: File[] | string;
    appraisalImagePath?: File[] | string;
  };
};

export function ProductDetail(props: ProductProps) {
  return (
    <Space direction="vertical">
      <AntImage
        className="w-full mb-2"
        style={{ aspectRatio: "1 / 1", objectFit: "cover" }}
        src={props.product.imageUrl}
      />
      <div>
        <span className="text-m font-bold">標題：</span>
        {props.product?.title}
      </div>
      <div>
        <span className="text-m font-bold">車廠：</span>
        {props.product?.brand.name}
      </div>
      <div>
        <span className="text-m font-bold">車款：</span>
        {props.product?.type}
      </div>
      <div>
        <span className="text-m font-bold">車種：</span>
        {props.product?.modal}
      </div>
      <div>
        <span className="text-m font-bold">車色：</span>
        {props.product?.color}
      </div>
      <div>
        <span className="text-m font-bold">車牌：</span>
        {props.product?.licensePlate}
      </div>
      <div>
        <span className="text-m font-bold">里程：</span>
        {numeral(props.product?.kilometers).format("0,0")}
      </div>
      <div>
        <span className="text-m font-bold">價錢：</span>
        {numeral(props.product?.price).format("$0,0")}
      </div>
      <div>
        <span className="text-m font-bold">出廠年份：</span>
        {props.product?.years}
      </div>
    </Space>
  );
}
